import FooterSale from "./components/FooterSale";

if (!window.customElements.get("arcteryx-sale-footer")) {
  window.customElements.define("arcteryx-sale-footer", FooterSale);
}
